import { Box } from "@mui/material";

interface NavigationMenuItemsWrapperProps {
  children: React.ReactNode;
}

export function NavigationMenuItemsWrapper(props: NavigationMenuItemsWrapperProps) {
  const { children } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        paddingY: 2,
        paddingX: 4,
        overflowY: "auto",
      }}
    >
      {children}
    </Box>
  );
}
